<div fxLayout="row" fxLayoutAlign="start center" 
    class="posting-cell"
    [ngClass]="postingCellClass"
    title="{{getPostingTitle}}">
    <div fxFlex="80" class="posting-cell-amount">
        {{ postingAmount }}
    </div>
    <div fxFlex="20" >
        <div [ngSwitch]="posting.purpose">
            <mat-icon *ngSwitchCase="'AutomatedAdjustment'">arrow_downward</mat-icon>
            <mat-icon *ngSwitchCase="'ManualAdjustment'">arrow_upward</mat-icon>
            <mat-icon *ngSwitchCase="'Disposal'">arrow_left</mat-icon>
            <mat-icon *ngSwitchCase="'DisposalReversal'">arrow_right</mat-icon>
            <mat-icon *ngSwitchCase="'DeletionInYear'">delete</mat-icon>
            <mat-icon *ngSwitchCase="'DeletionPriorYears'">delete</mat-icon>
            <mat-icon *ngSwitchCase="'DeletionReversal'">restart_alt</mat-icon>

            @if(prepayment){
                <mat-icon *ngSwitchCase="'AutomatedRelease'">arrow_upward</mat-icon>
                <mat-icon *ngSwitchCase="'AutomatedAccrual'">arrow_downward</mat-icon>
                <mat-icon *ngSwitchCase="'ManualRelease'">arrow_upward</mat-icon>
                <mat-icon *ngSwitchCase="'ManualAccrual'">arrow_downward</mat-icon>
                <mat-icon *ngSwitchCase="'Deletion'">delete</mat-icon>
                <mat-icon *ngSwitchCase="'DeletionReversal'">restart_alt</mat-icon>
            }
            @else{
                <mat-icon *ngSwitchCase="'AutomatedRelease'">arrow_downward</mat-icon>
                <mat-icon *ngSwitchCase="'AutomatedAccrual'">arrow_upward</mat-icon>
                <mat-icon *ngSwitchCase="'ManualRelease'">arrow_downward</mat-icon>
                <mat-icon *ngSwitchCase="'ManualAccrual'">arrow_upward</mat-icon>
                <mat-icon *ngSwitchCase="'Deletion'">delete</mat-icon>
                <mat-icon *ngSwitchCase="'DeletionReversal'">restart_alt</mat-icon>
            }

            
        </div>
    </div>
</div>